var _path, _path2, _g, _path3, _g2, _path4, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGooglePlayLogo = function SvgGooglePlayLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5AC9F4",
    d: "M.353.396C.123.643 0 1.012 0 1.49v17.269c0 .477.138.861.353 1.092l.062.062 9.658-9.681v-.23L.415.318.353.381"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "google_play_logo_svg__a",
    width: 9,
    height: 8,
    x: 10,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.283 13.477-3.209-3.232v-.23L13.3 6.781 17.183 9c1.09.615 1.09 1.63 0 2.247l-3.807 2.17-.077.046"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#google_play_logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_play_logo_svg__b)",
    d: "M18.243 6.799h-8.184v6.68h8.184z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "google_play_logo_svg__c",
    width: 14,
    height: 11,
    x: 0,
    y: 10,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.361 13.431-3.286-3.293-9.704 9.727c.353.385.952.43 1.612.046z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#google_play_logo_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_play_logo_svg__d)",
    d: "M6.871 3.604-4.703 15.205 6.87 26.806l11.574-11.6z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "google_play_logo_svg__e",
    width: 14,
    height: 11,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.361 6.827 1.983.347C1.323-.036.724.01.371.395l9.704 9.727z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#google_play_logo_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_play_logo_svg__f)",
    d: "M6.861-6.55-4.713 5.053 6.861 16.653 18.435 5.052z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_play_logo_svg__b",
    x1: 16.656,
    x2: -2.279,
    y1: 10.225,
    y2: 10.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FBBD0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F9A417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_play_logo_svg__d",
    x1: 11.012,
    x2: -6.838,
    y1: 11.254,
    y2: 29.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6176D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_play_logo_svg__f",
    x1: -6.803,
    x2: 7.487,
    y1: -8.903,
    y2: 5.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269E6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2BA06E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#52B26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6BBC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74C168"
  })))));
};
export default SvgGooglePlayLogo;